import { FC } from 'react';
import { Button, ButtonGroup, EmptyState } from '@/_components';
import type { EmptyFirmGroupsProps } from './EmptyFirmGroups.types';

export const EmptyFirmGroups: FC<EmptyFirmGroupsProps> = ({
  onCreateFirmGroup,
}) => {
  return (
    <EmptyState description="Organize your users with groups" icon="user">
      <ButtonGroup align="center">
        <Button
          onClick={onCreateFirmGroup}
          intent="primary"
          iconLeft="plus"
          value="Create"
        />
      </ButtonGroup>
    </EmptyState>
  );
};
